import {CLAIM_DETAIL, CLAIMS_DASHBOARD, CLAIMS_LIST, CLAIMS_REPAIR} from '../claims-commons/claims-commons-routing-roots';

export const CLAIMS_SUPERVISOR_DASHBOARD = CLAIMS_DASHBOARD;
export const CLAIMS_SUPERVISOR_LIST = CLAIMS_LIST;
export const CLAIMS_SUPERVISOR_DETAIL = CLAIM_DETAIL;
export const CLAIMS_SUPERVISOR_REPAIR = CLAIMS_REPAIR;
